import { useCallback, useEffect, useState } from "react";
import BootSequence from "./BootSequence";
import Navigation from "./Navigation";
import {
  About,
  Contact,
  Experience,
  Footer,
  Hero,
  Skills,
} from "./PortfolioSections";
// Projects,

function Monitor() {
  const [poweredOn, setPoweredOn] = useState(true);
  const [booting, setBooting] = useState(true);
  const [time, setTime] = useState("—:—:—");

  const finishBoot = useCallback(() => setBooting(false), []);
  const togglePower = (event) => {
    event.preventDefault();
    setPoweredOn((current) => !current);
    setBooting(true);
  };

  useEffect(() => {
    const updateClock = () =>
      setTime(new Date().toLocaleTimeString([], { hour12: false }));
    updateClock();
    const clock = window.setInterval(updateClock, 1000);
    return () => window.clearInterval(clock);
  }, []);

  return (
    <div className="monitor">
      <div className="monitor-brand">
        <span>◤ AMBEX&nbsp;9000 // MONO-DISPLAY</span>
        <span className="power-led">
          <span className={`led-dot ${poweredOn ? "" : "off"}`} /> PWR
        </span>
      </div>
      <div className="screen-frame">
        <Navigation onPowerToggle={togglePower} poweredOn={poweredOn} />
        <div
          className={`screen flicker ${poweredOn ? "powering-on" : "powering-off"}`}
        >
          <div className="screen-content">
            {poweredOn && booting ? (
              <BootSequence onComplete={finishBoot} poweredOn={poweredOn} />
            ) : null}
            {poweredOn && !booting ? (
              <div className="site visible">
                <Hero />
                <About />
                <Skills />
                {/* <Projects /> */}
                <Experience />
                <Contact />
                <Footer time={time} />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Monitor;
